import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ToastInfoComponent } from './toast-info/toast-info.component';
import { ToastSuccessfulComponent } from './toast-successful/toast-successful.component';
import { ToastErrorComponent } from './toast-error/toast-error.component';
import { ToastWarningComponent } from './toast-warning/toast-warning.component';

@Injectable({
  providedIn: 'root',
})

export class ToastService {

  private duracionToast = 2500;

  constructor(private toastr: ToastrService) { }

  public toastInfo(mensaje: string, accion?: string) {
    this.toastr.show(accion, mensaje, {
      timeOut: this.duracionToast,
      toastComponent: ToastInfoComponent,
      enableHtml: true,
      closeButton: true,
    });
  }

  public toastSuccessful(mensaje: string, accion?: string, datos?: any) {
    this.toastr.show(accion, mensaje, {
      timeOut: this.duracionToast,
      toastComponent: ToastSuccessfulComponent,
      payload: datos,
      enableHtml: true,
      closeButton: true,
    });
  }

  public toastError(mensaje: string, accion?: string) {
    this.toastr.show(accion, mensaje, {
      timeOut: this.duracionToast,
      toastComponent: ToastErrorComponent,
      enableHtml: true,
      closeButton: true,
    });
  }

  public toastWarning(mensaje: string, accion?: string) {
    this.toastr.show(accion, mensaje, {
      timeOut: this.duracionToast,
      toastComponent: ToastWarningComponent,
      enableHtml: true,
      closeButton: true,
    });
  }

}
